module.exports = __webpack_public_path__ + "media/testimonials/property-4-96a6cd93.jpg";